import BeelineLanding from '../beelineLp/BeelineLanding';

export default function Beeline3() {
  return <BeelineLanding lpKey="beeline3" lpName="KG Beeline 3 LP" variant={3} />;
}
